import { getSizedImageURL } from '../../core/images';

// product.variants.edges is grouped by size then color (XS/Cream, XS/Blue, ..., S/Cream, ...),
// while product.images.edges is grouped only by color. Using variant order to find the "next"
// color would wrongly wrap to the first color whenever the current color is last within its
// size block. astrImagesDetails lists colors in the same order images.edges is actually grouped,
// so it's used here instead to find the color boundary.
const findNextVariantImage = (variant) => {
  const product = window.theme.quickview.product;

  if (!product.astrImagesDetails || !product.astrImagesDetails.value) {
    return '';
  }

  const images_details = JSON.parse(product.astrImagesDetails.value.split('\"').join('"'));
  const color_option = variant.selectedOptions.find((option) => option.name === 'Color');

  if (!color_option) {
    return '';
  }

  const color_index = images_details.findIndex((detail) => detail.color_name === color_option.value);

  if (color_index === -1 || color_index === images_details.length - 1) {
    return '';
  }

  return images_details[color_index + 1].front_image_url;
};

// next_color_image is empty when the variant is the last one in the list
const getVariantImages = (product_images, variant_image, next_color_image) => {
  console.log(product_images, variant_image, next_color_image);
  const variant_images = [];

  let image_found = false;
  for (let i = 0; i < product_images.length; i++) {
    const product_image = product_images[i].node.url;

    if (product_image === variant_image) {
      image_found = true;
      variant_images.push(product_image);
      continue;
    }

    if (product_image === next_color_image) {
      break;
    }

    if (image_found) {
      variant_images.push(product_image);
    }
  }

  return variant_images;
};

export default (variant, total_images = 6) => {
  try {
    if (window.theme.quickview.product === null) {
      throw new Error('Missing product data');
    }

    const product_images = window.theme.quickview.product.images.edges;

    if (product_images === null || product_images.length === 0 || variant.image === null) {
      return '';
    }

    const next_color_image = findNextVariantImage(variant);
    const variant_images = getVariantImages(product_images, variant.image.url, next_color_image);
    const edit_mode = document.body.classList.contains('edit-cart');

    let images_html = '';
    for (let i = 0; i < variant_images.length; i++) {
      const image_pos = i + 1;
      const is_plus_size_available = window.theme.quickview?.product?.variants?.edges?.some(v => v.node.title.includes('Plus Size -'));
      const is_plus_size_variant = variant.title.includes('Plus Size -');

      if (i < total_images) {
        images_html += `
          <li ref="media[]" class="product-media-container">
            <div class="product-main" data-product-main tabindex="0" role="tabpanel" data-image-pos="${image_pos}">
              <img class="product-main__image no-themed" src="${getSizedImageURL(variant_images[i], '500x')}" alt="${window.theme.quickview.product.title} - ${variant.title.split('/')[0]} - Image ${image_pos}" tabindex="0" role="button" aria-haspopup="dialog" aria-expanded="false"${window.theme.breakpoints.current === 'mobile' || edit_mode ? '' : ` data-zoom="${getSizedImageURL(variant_images[i], '1024x')}"`} />

              ${(image_pos === 1 || (window.theme.breakpoints.current !== 'mobile' && image_pos === 2)) ? `
                <div class="product-main__info product-main-info">
                  ${is_plus_size_available && !is_plus_size_variant ? `<div class="product-main-info__item">Plus Sizes</div>` : ''}
                  <div class="product-main-info__item product-main-info__item--model visually-hidden">
                    <span class="product-main-info__text">Model is <span data-quickview-extra-sizefit-height></span></span>
                    <span class="product-main-info__text">wearing size <span data-quickview-extra-sizefit-size></span></span>
                  </div>
                </div>
              ` : ''}
          </div>
        </li>`;
      }
    }

    return images_html;
  } catch (error) {
    console.log('Product images error', error);
    return '';
  }
};
